<div class="category mat-h1">Data Quality Issues</div>
@if (issueGroups.length) {
  <div class="description">
    <p>
      The following data quality issues were identified. 
      If possible, please upload a new file that fixes 
      identified issues. Once the new data file is 
      uploaded, press <b>Check Data Quality</b> to re-run 
      the checks.
    </p>
  </div>
}
<div class="issue-list-container">
  @if (issueGroups.length === 0) {
    <div class="no-issues">
      <span><mat-icon>done</mat-icon></span>
      <span>No issues found.</span>
    </div>
  }
  @for (group of issueGroups; track group) {
    <div class="issue-group">
      <div class="issue-group-header">
        <h3 class="group-label">
          {{ group.label }}
        </h3>
        <mat-chip-set readonly>
          <mat-chip class="issue-count"
            >Issues: {{ group.issueCount }}</mat-chip
          >
        </mat-chip-set>
      </div>
      @for (issue of group.list; track issue; let index = $index) {
        <div class="issue-container">
          <app-fpar-issue
            [canResolve]="canResolve"
            [issue]="issue"
            [index]="index"
            [grant]="{ grantId, tableId }"
            [readOnly]="readOnly"
            [reportingPeriodId]="reportingPeriodId"
            [systemForcedStatusChange]="systemForcedStatusChange"
            (editingComments)="setEditingComments($event)"
            (hold)="markOnHold(grantId, tableId, $event)"
            (resolve)="setResolution(grantId, $event)"
            (activateSubIssue)="onActivateSubIssue($event)"
          ></app-fpar-issue>
        </div>
      }
    </div>
  }
</div>
